import React, { Component } from "react";
import { connect } from "react-redux";
import "react-datetime/css/react-datetime.css";

import Preloader from "../Preloader";
import ClientService from "../../services/Initialization/ClientService";
import { Form } from "./Form";
import { ClientAccountInfo } from "./ClientAccountInfo";

class ClientAccount extends Component {
  state = {
    sendForm: false,
    isLoading: false,
    noData: false,
  };
  componentDidMount() {
    this.setState({ isLoading: true });
    ClientService.getTRClientDetails().then((res) => {
      this.setState({ formValues: res });
      this.setState({ isLoading: false });
    });
  }

  handleSubmit = (values, cb) => {
    ClientService.updateTRClient(values)
      .then(() => {
        ClientService.getTRClientDetails().then((res) => {
          this.setState({ formValues: res, sendForm: true });
          cb();
        });
      })
      .catch((error) => cb());
  };

  render() {
    const _ = this.props._;
    return (
      <div className="portal-client">
        <h2>{_.ClientHub.ClientAccount}</h2>
        {this.state.isLoading && <Preloader />}
        {this.state.noData ? (
          <div className="d-flex report-sent-message">
            <h6>This client does not have any details to amend.</h6>
          </div>
        ) : this.state.sendForm ? (
          <ClientAccountInfo
            {...this.state.formValues}
            _={_}
            backtoForm={() => this.setState({ sendForm: false })}
          />
        ) : (
          this.state.formValues && (
            <Form
              _={_}
              formValues={this.state.formValues}
              handleSubmit={this.handleSubmit}
            />
          )
        )}
      </div>
    );
  }
}

export const mapStateToProps = ({ _ }) => ({ _ });

export default connect(mapStateToProps)(ClientAccount);
